import { types } from "../types/types";
import { finishSpinner, startSpinner } from "./ui/spinner";
import ArchivosContratacionesService from "../services/ArchivosContratacionesService"
import { startAlerta } from "./ui/alertas";
import { handleErrorApi } from "../helpers/randoms";
import axios from "axios";
import { TIPOS_ARCHIVOS_CONTRATACIONES } from "../utils/constants";

const baseUrl = process.env.REACT_APP_API_URL;

export const setArchivosContrataciones = (payload) => async (dispatch) => {
    dispatch({
        type: types.archivosContratacionesSuccess,
        payload
    })
}

export const getArchivosContrataciones = (tipoArchivo, fechaDesde, fechaHasta ) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.archivosContratacionesTraer })
    try {
        const result = await ArchivosContratacionesService.getArchivosContratos(
            fechaDesde !== null ? fechaDesde.toISOString() : new Date('1970-01-01').toISOString(),
            fechaHasta !== null ? fechaHasta.toISOString() : new Date('2099-01-01').toISOString(),
            tipoArchivo)
        const body = await result.json()
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch({
                type: types.archivosContratacionesSuccess,
                payload: body
            })
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.archivosContratacionesError })
        if (error?.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const getParametrosContrataciones = () => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.parametrosContratacionesTraer })
    try {
        const result = await ArchivosContratacionesService.getParametrosContratos()
        const body = await result.json()
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch({
                type: types.parametrosContratacionesSuccess,
                payload: body
            })

        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.parametrosContratacionesError })
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const subirArchivoContrataciones = (file, tipoArchivo) => async (dispatch) => {
    dispatch(startSpinner());
    const url = `${baseUrl}/FileUpload/UploadFile/ArchivosContrataciones/${tipoArchivo}`;
    const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    let httpHeaders;
    if (token) {
        httpHeaders = {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        };
    }
    const formData = new FormData();
    formData.append("files", file);
    try {
        const result = await fetch(url, {
            method: "POST",
            body: formData,
            headers: httpHeaders
        });
        const body = await result.json();
        if (result.ok) {
            dispatch(getArchivosContrataciones(tipoArchivo, null, null))
            dispatch(startAlerta("Archivo cargado correctamente.", "success"))
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al subir el archivo",
            "Ha ocurrido un error. Intente nuevamente",
            false
        );
    }
};

export const DescargarPlantillaExcelContrataciones = (tipoArchivo) => async (dispatch, getState) => {
    let file;
    if(tipoArchivo === TIPOS_ARCHIVOS_CONTRATACIONES.CMP){
        file = "Planilla-Carga-Prestadores-CMP.xls";
    }else if(tipoArchivo === TIPOS_ARCHIVOS_CONTRATACIONES.EQUIVALENCIAS){
        file = "Planilla-Carga-Equivalencias-Nomenclador.xls";
    }else if(tipoArchivo === TIPOS_ARCHIVOS_CONTRATACIONES.MODULOS){
        file = "Planilla-Carga-Relaciones-Modulo.xls";
    }
    const url = `${process.env.REACT_APP_URL}/public-templates/${file}`;

    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token") || "";
    let httpHeaders;
    if (token) {
      httpHeaders = {
        Authorization: `Bearer ${token}`,
      };
    }
    try {
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
        headers: httpHeaders,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file);
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al subir el archivo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };